import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import MainDatatable from "../../components/common/MainDatatable.jsx";
import { DeleteSvg, EditSvg, SwitchOffSvg, SwitchOnSvg, ViewSvg } from "../../assets/svg/index.js";
import { api_urls } from "../../utils/api-urls/index.js";
import * as TestimonialsActions from '../../redux/actions/testimonialsAction.js';
import { useNavigate } from "react-router-dom";
import logo_icon from '../../assets/images/logo_icon.png'
import { CloseRounded } from "@mui/icons-material";
import { Avatar, Dialog, DialogContent, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";

const DisplayTestimonials = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { testimonialData } = useSelector(state => state?.testimonialsReducer)
  const [editModalVisible, setEditModalVisible] = useState(false)
  const [testimonialsDetail, setTestimonialsDetail] = useState({ testimonialId: '', name: '', designation: '', institution: '', description: '', status: '' });
  const [inputFieldError, setInputFieldError] = useState({ name: "Please Provide Name", email: "Please Provide Email" });
  const [testimonialsImage, setTestimonialsImage] = useState({ file: logo_icon, bytes: "" });

  //* Handle Input Field : Error
  const handleInputFieldError = (input, value) => {
    setInputFieldError((prev) => ({ ...prev, [input]: value }))
  }

  //* Handle Input Field : Data
  const handleInputField = (e) => {
    const { name, value } = e.target;
    setTestimonialsDetail({ ...testimonialsDetail, [name]: value });
  };

  //* Handle Testimonials Image
  const handleTestimonialsImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setTestimonialsImage({
        file: URL.createObjectURL(e.target.files[0]),
        bytes: e.target.files[0],
      });
    }
  };

  //! Handle Submit - Creating Testimonials
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Testimonials Data :: ", { ...testimonialsDetail, testimonialsImage })
    const { testimonialId, name, designation, institution, description, status } = testimonialsDetail;

    let formData = new FormData()
    formData.append("testimonialId", testimonialId)
    formData.append("name", name)
    formData.append("designation", designation)
    formData.append("institution", institution)
    formData.append("description", description)
    formData.append("status", status);
    formData.append("testimonialImage", testimonialsImage.bytes);

    const payload = {
      data: formData,
      onComplete: () => setEditModalVisible(false)
    }

    //! Dispatching API for Updating Testimonials
    dispatch(TestimonialsActions.updateTestimonials(payload))
  };

  //! Handle Edit - Testimonials
  const handleEdit = (data) => {
    setEditModalVisible(!editModalVisible)
    console.log("Edit Data ::: ", data)

    setTestimonialsDetail({
      testimonialId: data?._id || '',
      name: data?.name || '',
      designation: data?.designation || '',
      institution: data?.institution || '',
      description: data?.description || '',
      status: data?.status || ''
    });
    setTestimonialsImage({
      file: api_urls + data?.testimonialImage || logo_icon
    })
  }

  //* Testimonials DataTable Columns
  const testimonialsColumns = [
    { name: 'S.No.', selector: row => testimonialData.indexOf(row), style: { backGroundColor: "#000", paddingLeft: "20px" } },
    { name: 'Name', selector: row => row?.name },
    { name: 'Designation', selector: row => row?.designation },
    { name: 'Institution', selector: row => row?.institution },
    { name: 'Description', selector: row => row?.description },
    { name: 'Image', cell: row => <img src={api_urls + row?.testimonialImage} alt="Profile" style={{ width: '50px', height: '50px', borderRadius: '50%' }} /> },
    { name: 'Status', selector: row => <div onClick={() => dispatch(TestimonialsActions?.changeTestimonialsStatus({ testimonialId: row?._id }))} style={{ cursor: "pointer" }}>{row?.status == 'Active' ? <SwitchOnSvg /> : <SwitchOffSvg />}</div> },
    {
      name: 'Action',
      cell: row => <div style={{ display: "flex", gap: "20px", alignItems: "center" }} >
        <div onClick={() => handleEdit(row)} style={{ cursor: "pointer" }}><EditSvg /></div>
        <div onClick={() => dispatch(TestimonialsActions?.deleteTestimonials({ testimonialId: row?._id }))} style={{ cursor: "pointer" }}><DeleteSvg /></div>
      </div>,
      width: "180px"
    },
  ];

  useEffect(() => {

    //! Dispatching API for Getting Testimonials
    // dispatch(TestimonialsActions.getTestimonials())
  }, [])

  return (
    <>
      <MainDatatable data={testimonialData} columns={testimonialsColumns} title={'Testimonials'} url={'/add-testimonials'} />


      <Dialog
        open={editModalVisible}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item lg={12} sm={12} md={12} xs={12} sx={{ marginBottom: "20px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ fontSize: "23px", fontWeight: "600" }}>Edit Testimonials</div>
                <div onClick={() => setEditModalVisible(false)}><CloseRounded /></div>
              </div>
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12} >
              <TextField
                label="Name" variant='outlined' fullWidth
                name='name'
                value={testimonialsDetail?.name}
                onChange={handleInputField}
              />
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12} >
              <TextField
                label="Designation" variant='outlined' fullWidth
                name='designation'
                value={testimonialsDetail?.designation}
                onChange={handleInputField}
              />
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12} >
              <TextField
                label="Institution" variant='outlined' fullWidth
                name='institution'
                value={testimonialsDetail?.institution}
                onChange={handleInputField}
              />
            </Grid>

            {/* <Grid item lg={1} sm={6} md={6} xs={6} >
              <Avatar
                color={Colors.primaryDark}
                src={testimonialsImage.file}
                style={{ width: 40, height: 40 }}
              />
            </Grid>
            <Grid item lg={5} sm={6} md={6} xs={6} className={classes.uploadContainer}   >
              <Grid component="label" className={classes.uploadImageButton}>
                Upload Testimonials Image
                <input onChange={handleTestimonialsImage} hidden accept="image/*" type="file" />
              </Grid>
            </Grid> */}

            <Grid item lg={6} md={6} sm={12} xs={12} >
              <TextField
                label="Description" variant='outlined' fullWidth
                name='description'
                value={testimonialsDetail?.description}
                onChange={handleInputField}
              />
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12} >
              <FormControl fullWidth>
                <InputLabel id="select-label">Select Status</InputLabel>
                <Select
                  label="Select Status" variant="outlined" fullWidth
                  name='status'
                  value={testimonialsDetail?.status}
                  onChange={handleInputField}
                >
                  <MenuItem disabled>---Select Status---</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item lg={12} sm={12} md={12} xs={12} >
              <Grid container spacing={2}>
                <Grid item lg={6} sm={6} md={6} xs={6} >
                  <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px", textAlign: "center", fontFamily: "Philosopher" }}>Submit</div>
                </Grid>
                <Grid item lg={6} sm={6} md={6} xs={6} >
                  <div onClick={() => setEditModalVisible(false)} style={{ fontWeight: "500", backgroundColor: "#EDF2F5", color: "#000", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px", textAlign: "center", fontFamily: "Philosopher" }}>
                    Close
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </ >
  );
}

export default DisplayTestimonials;